import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const usePromoEditPageRedirect = () => {
  return usePagesRedirect('promo-edit-page');
};
